import { render } from "./AddCommentsToTicket.vue?vue&type=template&id=5b59a152"
import script from "./AddCommentsToTicket.vue?vue&type=script&lang=js"
export * from "./AddCommentsToTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__